"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.excludeProps = excludeProps;
exports.getKey = getKey;

/**
 * SPDX-FileCopyrightText: © 2022 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */

/**
 * Helper function to create a unique key for list or tree when defined by
 * developer data or obtained by component in React.
 */
function getKey(index, key, parentKey) {
  if (key != null && (!String(key).startsWith('.') || String(key).startsWith('.$'))) {
    return key;
  }

  return parentKey ? "".concat(parentKey, ".").concat(index) : "$.".concat(index);
}
/**
 * Helper function for omitting properties of an object, similar to
 * TypeScript's Omit<T, K>.
 */


function excludeProps(props, items) {
  return Object.keys(props).reduce(function (previous, key) {
    if (!items.has(key)) {
      previous[key] = props[key];
    }

    return previous;
  }, {});
}